import React, {FC} from 'react';

/** Русская версия текста «Условий использования» (i18n: оболочка выбирает компонент содержимого по языку; имена классов повторно используют BEM-блок TermsOfUse__*) — 2026-09-17 AI-перевод, юридические формулировки ожидают проверки бизнесом */
const RuContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">Дата вступления в силу: August 28, 2026</p>
      <p className="v3-doc-meta">Дата последнего обновления: August 28, 2026</p>
      <p>Благодарим Вас за использование продуктов и услуг, предоставляемых Xiangji!</p>
      <p>
        Настоящие «Пользовательские условия использования Xiangji» (далее — «Условия») представляют собой соглашение,
        заключаемое между Вами и <strong>[полное юридическое наименование фактического оператора Xiangji]</strong>{' '}
        (далее — «Xiangji», «мы» или «нас») в отношении регистрации, входа и использования связанных с Xiangji продуктов
        и услуг.
      </p>
      <p>
        Xiangji в первую очередь предоставляет услуги обработки и создания визуального контента на основе искусственного
        интеллекта (ИИ) для трансграничной электронной торговли и других бизнес-пользователей, включая, помимо прочего,
        перевод изображений, редактирование изображений, генерацию изображений, генерацию предметных сцен для товаров,
        генерацию изображений с товарными моделями, генерацию комплектов детальных изображений товаров, генерацию
        главных и дополнительных изображений товаров, создание маркетинговых материалов и другие сопутствующие услуги.
      </p>
      <p>
        <strong>
          Просим Вас внимательно прочитать настоящие Условия и убедиться в их полном понимании до использования услуг
          Xiangji, в особенности положения, выделенные полужирным шрифтом и касающиеся Ваших существенных прав и
          интересов, включая, помимо прочего, положения об отказе от гарантий, об ограничении ответственности, о
          пользовательском контенте и интеллектуальной собственности, о контенте, сгенерированном ИИ, об изменении
          услуг, об управлении учётными записями, о юридической ответственности и о разрешении споров.
        </strong>
      </p>
      <p>
        Если Вы не согласны с каким-либо или со всеми положениями настоящих Условий, просим не регистрироваться, не
        входить в систему и не использовать услуги Xiangji.
      </p>
      <p>
        Нажимая на веб-страницах такие кнопки, как «Согласиться», «Зарегистрироваться», «Войти», «Начать работу» или
        «Подтвердить», либо фактически осуществляя регистрацию, вход, покупку или использование услуг Xiangji, Вы будете
        считаться прочитавшими, понявшими и принявшими все положения настоящих Условий.
      </p>
      <p>
        Если Вы используете услуги Xiangji от имени предприятия, учреждения или иной организации, Вы заверяете и
        подтверждаете, что надлежащим образом уполномочены принять настоящие Условия от имени такого предприятия,
        учреждения или организации, и что соответствующая организация будет нести соответствующую ответственность.
      </p>
      <section>
        <h2>1. Сфера применения настоящих Условий и их подтверждение</h2>
        <h3>Xiangji и продуктовые услуги</h3>
        <p>
          В настоящих Условиях под «Xiangji» и «Платформой» понимаются компания 苏州象寄科技服务有限公司 (Сучжоуская
          компания технологических услуг «Сянцзи») и эксплуатируемые ею веб-сайт, веб-приложения, клиенты, браузерные
          расширения и другие связанные продукты и услуги.
        </p>
        <p>Официальный веб-сайт Xiangji:</p>
        <p>
          <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
            <strong>https://www.xiangjifanyi.com/</strong>
          </a>
        </p>
        <p>
          Конкретный состав предоставляемых услуг определяется фактически доступными функциями продуктов, сервисными
          страницами Xiangji и связанными с ними правилами.
        </p>
        <h3>Продуктовые услуги</h3>
        <p>
          Под «продуктовыми услугами» понимаются различные связанные с интернетом и ИИ услуги, предоставляемые Xiangji
          пользователям, включая, помимо прочего:
        </p>
        <ul>
          <li>перевод изображений;</li>
          <li>редактирование и ретушь изображений;</li>
          <li>обработка фона изображений;</li>
          <li>генерация товарных изображений;</li>
          <li>генерация предметных сцен для товаров;</li>
          <li>генерация изображений с товарными моделями;</li>
          <li>генерация главных и дополнительных изображений товаров;</li>
          <li>генерация комплектов детальных изображений товаров;</li>
          <li>генерация страниц товарных карточек, A+-контента и иного контента;</li>
          <li>обработка видео и визуального контента;</li>
          <li>обработка файлов и связанных с PSD операций;</li>
          <li>API и иные технические услуги;</li>
          <li>иные сопутствующие услуги, которые Xiangji будет запускать в будущем.</li>
        </ul>
        <p>
          <strong>
            Конкретное содержание, функции, стандарты обслуживания, способы тарификации и правила использования услуг
            определяются фактически предоставляемыми Xiangji услугами и описаниями на соответствующих страницах.
          </strong>
        </p>
        <h3>Иные соглашения</h3>
        <p>
          Настоящие Условия вместе с Политикой конфиденциальности Xiangji, соглашениями, касающимися создания контента с
          помощью ИИ, Соглашением о приобретении подписки, Соглашением об использовании API и другими специальными
          правилами оказания услуг образуют систему условий обслуживания Xiangji.
        </p>
        <p>
          При использовании конкретной услуги Xiangji Вы также обязаны соблюдать применимое к такой услуге специальное
          соглашение или правила.
        </p>
        <p>
          В случае противоречия между специальным соглашением и настоящими Условиями в отношении соответствующих
          вопросов преимущественную силу имеют положения специального соглашения.
        </p>
        <h3>Внесение изменений в настоящие Условия</h3>
        <p>
          <strong>
            С учётом стремительного развития технологий интернета и искусственного интеллекта Xiangji оставляет за собой
            право изменять или дополнять настоящие Условия в связи с изменениями нормативных правовых актов, развитием
            бизнеса, технологическими обновлениями и корректировками услуг.
          </strong>
        </p>
        <p>
          О существенных изменениях настоящих Условий Xiangji уведомит Вас посредством объявлений на веб-сайте, на
          страницах продуктов, во всплывающих окнах, внутри продуктовых уведомлений или иным разумным способом.
        </p>
        <p>Изменённые Условия вступают в силу с даты публикации или с даты вступления в силу, указанной в них.</p>
        <p>
          <strong>
            Если Вы не согласны с изменёнными Условиями, Вам следует прекратить использование соответствующих услуг;
            продолжение доступа к услугам Xiangji или их использования будет означать принятие Вами изменённых Условий.
          </strong>
        </p>
      </section>
      <section>
        <h2>2. Регистрация учётной записи и её безопасность</h2>
        <h3>Регистрация учётной записи</h3>
        <p>
          Для использования отдельных услуг Xiangji может потребоваться регистрация учётной записи Xiangji или вход в
          неё.
        </p>
        <p>
          Вы обязаны предоставлять достоверную, точную и полную информацию в соответствии с требованиями страницы
          регистрации, а также своевременно актуализировать такую информацию.
        </p>
        <p>
          <strong>
            Запрещается регистрировать или использовать учётную запись Xiangji путём предоставления недостоверной
            информации, подмены или неправомерного использования идентификационных данных другого лица либо иными
            ненадлежащими способами.
          </strong>
        </p>
        <h3>Безопасность учётной записи</h3>
        <p>Вы отвечаете за надлежащую охрану своей учётной записи, пароля и иных средств аутентификации личности.</p>
        <p>Вы несёте ответственность за все операции, совершённые через Вашу учётную запись.</p>
        <p>
          Вы несёте убытки, возникшие вследствие разглашения, незаконного присвоения или несанкционированного
          использования другими лицами Вашей учётной записи, пароля, кода подтверждения или иных подобных сведений по
          Вашим собственным причинам.
        </p>
        <h3>Совместное использование учётной записи</h3>
        <p>
          За исключением прямо предусмотренных Xiangji функций, таких как корпоративная версия и многопользовательское
          сотрудничество,{' '}
          <strong>
            Вы не вправе предоставлять другим лицам доступ к учётной записи путём сдачи её в аренду, предоставления в
            пользование, продажи, передачи или совместного использования.
          </strong>
        </p>
        <p>
          Если Xiangji обнаружит, что в отношении учётной записи имеет место аномальный совместный доступ, массовое
          использование, недобросовестная регистрация, аномальные вызовы API или иное поведение, которое может поставить
          под угрозу безопасность Платформы, Xiangji оставляет за собой право применить такие меры, как ограничение
          входа, ограничение функций, приостановка услуг или удаление учётной записи.
        </p>
        <h3>Сторонние учётные записи</h3>
        <p>
          Если Вы входите в Xiangji через учётную запись Google, WeChat или иную стороннюю учётную запись, Вы обязаны
          соблюдать правила обслуживания соответствующей сторонней платформы.
        </p>
        <p>
          Xiangji не несёт ответственности в случаях, когда невозможность входа или использования услуг Xiangji
          обусловлена причинами, относящимися к самой сторонней учётной записи.
        </p>
        <h3>Аннулирование учётной записи</h3>
        <p>Вы можете подать заявку на аннулирование учётной записи способами, предоставленными Xiangji.</p>
        <p>
          <strong>
            После аннулирования учётной записи связанные с ней сервисные преимущества, неиспользованные кредиты,
            исторические данные и иное содержание могут быть удалены или утратить силу в соответствии с применимыми
            правилами Xiangji, если иное не предусмотрено нормативными правовыми актами или не согласовано сторонами.
          </strong>
        </p>
      </section>
      <section>
        <h2>3. Правила использования</h2>
        <p>
          Используя услуги Xiangji, Вы обязуетесь соблюдать законодательство Китайской Народной Республики и других
          применимых стран и регионов, а также общепринятые нормы морали, общественный порядок и добрые нравы.
        </p>
        <p>Вы не вправе использовать услуги Xiangji для совершения каких-либо из следующих действий:</p>
        <h3>Незаконный либо не соответствующий требованиям контент</h3>
        <p>Вы не вправе создавать, генерировать, загружать, публиковать, распространять или хранить:</p>
        <ul>
          <li>контент, нарушающий законодательство;</li>
          <li>
            контент, создающий угрозу национальной безопасности, общественной безопасности или социальной стабильности;
          </li>
          <li>
            контент непристойного, порнографического, насильственного, террористического или экстремистского характера;
          </li>
          <li>мошенничество, азартные игры, финансовые пирамиды или иной противоправный контент;</li>
          <li>контент, содержащий оскорбления, клевету или домогательства в отношении других лиц;</li>
          <li>иной контент, запрещённый законодательством.</li>
        </ul>
        <h3>Нарушение прав третьих лиц</h3>
        <p>
          Вы не вправе использовать услуги Xiangji для нарушения законных прав и интересов третьих лиц, включая, помимо
          прочего:
        </p>
        <ul>
          <li>авторские права;</li>
          <li>права на товарные знаки;</li>
          <li>патентные права;</li>
          <li>права на изображение гражданина;</li>
          <li>права на неприкосновенность частной жизни;</li>
          <li>права на репутацию;</li>
          <li>коммерческую тайну;</li>
          <li>иные законные права и интересы.</li>
        </ul>
        <h3>Недостоверный и вводящий в заблуждение контент</h3>
        <p>
          Вы не вправе использовать услуги Xiangji для создания или распространения недостоверного, мошеннического или
          вводящего потребителей в заблуждение контента, а также иного контента, который может нанести ущерб законным
          правам и интересам других лиц.
        </p>
        <h3>Недобросовестное использование</h3>
        <p>
          Вы не вправе использовать программы, скрипты, ботов, краулеры или иные автоматизированные средства, чтобы:
        </p>
        <ul>
          <li>осуществлять массовую регистрацию учётных записей;</li>
          <li>злонамеренно обращаться к услугам;</li>
          <li>обходить ограничения на использование;</li>
          <li>взламывать механизм тарификации или уклоняться от него;</li>
          <li>мошенническим путём получать сервисные кредиты;</li>
          <li>препятствовать нормальной работе Платформы;</li>
          <li>проводить стресс-тесты или атаки в отношении Платформы.</li>
        </ul>
        <h3>Системы и технические средства защиты</h3>
        <p>
          <strong>
            Без предварительного письменного разрешения Xiangji запрещается осуществлять обратную разработку,
            декомпиляцию, дизассемблирование, взлом, копирование, изменение или иной технический анализ веб-сайта,
            программного обеспечения, интерфейсов, серверов, моделей и иных технических систем Xiangji.
          </strong>
        </p>
        <p>Вы не вправе:</p>
        <ul>
          <li>взламывать программы Платформы;</li>
          <li>изменять или искажать функции Платформы;</li>
          <li>обходить технические средства защиты;</li>
          <li>получать несанкционированный доступ к серверам;</li>
          <li>получать непубличные данные;</li>
          <li>выявлять уязвимости безопасности Платформы и проводить атаки;</li>
          <li>иным образом вмешиваться в нормальную работу Платформы.</li>
        </ul>
        <h3>Иное запрещённое поведение</h3>
        <p>
          Вы не вправе совершать какие-либо иные действия, нарушающие законодательство, настоящие Условия или иные
          правила обслуживания Xiangji.
        </p>
      </section>
      <section>
        <h2>4. Загружаемый пользователем контент</h2>
        <h3>Пользовательский контент</h3>
        <p>
          Под «пользовательским контентом» понимаются текст, изображения, фотографии, видео, аудио, информация о
          товарах, файлы дизайна, файлы PSD и иной контент, которые Вы загружаете, передаёте, вводите, генерируете,
          редактируете, сохраняете или иным образом предоставляете Xiangji в процессе использования услуг Xiangji.
        </p>
        <h3>Заверение о правах</h3>
        <p>
          <strong>
            Вы обязаны обеспечить правомерность происхождения предоставляемого Xiangji пользовательского контента и
            наличие всех прав, разрешений и лицензий, необходимых для использования такого контента.
          </strong>
        </p>
        <p>
          В частности, если контент включает изображения третьих лиц, товарные изображения, товарные знаки брендов,
          шрифты, музыку, кино- и телепроизведения, дизайнерские произведения или иной подобный контент, Вы обязаны
          обеспечить получение необходимых разрешений.
        </p>
        <h3>Право собственности на пользовательский контент</h3>
        <p>
          Если иное не предусмотрено нормативными правовыми актами или не согласовано сторонами, права, которыми Вы
          обладаете в отношении правомерно принадлежащего Вам пользовательского контента, не изменяются в результате
          использования Вами услуг Xiangji.
        </p>
        <p>
          В силу настоящих Условий Xiangji не приобретает право собственности на Ваш пользовательский контент на
          безвозмездной основе.
        </p>
        <h3>Лицензия, необходимая для оказания услуг</h3>
        <p>
          Для оказания Вам услуг Вы соглашаетесь предоставить Xiangji{' '}
          <strong>неисключительную, действующую во всём мире, безвозмездную лицензию</strong>, позволяющую Xiangji в
          объёме, необходимом для предоставления, поддержки, оптимизации и улучшения соответствующих услуг, хранить,
          воспроизводить, передавать, обрабатывать, анализировать и осуществлять техническую обработку Вашего
          пользовательского контента.
        </p>
        <p>Данная лицензия действует в течение срока, необходимого для достижения указанных целей обслуживания.</p>
        <h3>Удаление контента</h3>
        <p>
          Если Xiangji обнаружит или получит сообщение (жалобу) о том, что загруженный или сгенерированный Вами контент
          может нарушать законодательство, настоящие Условия или законные права и интересы третьих лиц, Xiangji
          оставляет за собой право с учётом фактических обстоятельств удалить или заблокировать такой контент,
          ограничить доступ к нему либо принять иные разумные меры.
        </p>
      </section>
      <section>
        <h2>5. Особые положения о контенте, генерируемом ИИ</h2>
        <p>
          Часть услуг Xiangji предоставляется на основе моделей искусственного интеллекта, генеративных ИИ-технологий,
          алгоритмов машинного обучения и сторонней ИИ-инфраструктуры.
        </p>
        <h3>Неотъемлемая неопределённость результатов генерации</h3>
        <p>
          <strong>
            Вы понимаете и соглашаетесь, что результаты, генерируемые ИИ, в определённой степени неопределённы, и что
            Xiangji не может гарантировать, что сгенерированные результаты всегда будут точными, полными, достоверными,
            правомерными, соответствующими Вашим ожиданиям или свободными от сходства с произведениями третьих лиц.
          </strong>
        </p>
        <p>Результаты генерации могут содержать:</p>
        <ul>
          <li>несоответствие содержания изображения исходным данным;</li>
          <li>ошибки в деталях товаров;</li>
          <li>ошибки в структуре или пропорциях товаров;</li>
          <li>ошибки распознавания или перевода текста;</li>
          <li>аномальную генерацию людей или сцен;</li>
          <li>фактические ошибки;</li>
          <li>иные проблемы, присущие самой технологии генерации ИИ.</li>
        </ul>
        <h3>Ответственность за проверку человеком</h3>
        <p>
          <strong>
            Вы обязаны выполнять проверку человеком итогового контента, сгенерированного, переведённого,
            отредактированного или иным образом обработанного ИИ.
          </strong>
        </p>
        <p>
          В частности, в отношении информации, способной повлиять на решения потребителей, — такой как цены на товары,
          размеры, характеристики, материалы, функции, эксплуатационные показатели, сертификаты и заявленная
          эффективность, — Вы обязаны самостоятельно проверять её до публикации, продажи или рекламы.
        </p>
        <p>
          Вы несёте установленную законом ответственность за любые убытки или споры, возникшие вследствие использования
          Вами сгенерированного ИИ контента напрямую без проверки.
        </p>
        <h3>Отсутствие гарантии уникальности результатов генерации</h3>
        <p>Одинаковые или похожие исходные данные могут порождать одинаковые или различные результаты.</p>
        <p>
          Xiangji не гарантирует уникальности результатов, генерируемых ИИ, и не гарантирует, что другие пользователи не
          сгенерируют контент, похожий на Ваш или идентичный ему.
        </p>
        <h3>Сторонние модели</h3>
        <p>
          Некоторые функции Xiangji могут использовать сторонние ИИ-модели, системы перевода, облачные службы или иные
          сторонние технические службы.
        </p>
        <p>
          <strong>
            Если соответствующие услуги затрагиваются сбоями, обновлениями, ограничениями, корректировками,
            приостановкой или прекращением сторонних моделей или служб, Xiangji, если иное не предусмотрено законом,
            примет в разумных пределах замещающие или восстановительные меры.
          </strong>
        </p>
        <h3>Коммерческое использование контента, сгенерированного ИИ</h3>
        <p>
          Пользователи обязаны использовать сгенерированный ИИ контент в соответствии с применимым законодательством,
          условиями обслуживания сторонних моделей и специальными продуктовыми правилами Xiangji.
        </p>
        <p>
          <strong>
            В отношении контента, используемого в сценариях коммерческой публикации, размещения рекламы или продажи
            товаров, пользователи обязаны самостоятельно убедиться в наличии правомерных оснований такого использования
            и нести соответствующую ответственность за коммерческое использование.
          </strong>
        </p>
      </section>
      <section>
        <h2>6. Интеллектуальная собственность</h2>
        <h3>Интеллектуальная собственность Xiangji</h3>
        <p>
          <strong>
            Права интеллектуальной собственности на веб-сайт, программное обеспечение, продукты, дизайн страниц,
            товарные знаки, логотипы, тексты, изображения, программы, алгоритмы, модели, базы данных, техническую
            документацию и иной предоставляемый Xiangji контент принадлежат Xiangji или соответствующим
            правообладателям.
          </strong>
        </p>
        <p>Без письменного разрешения Xiangji или соответствующих правообладателей Вы не вправе:</p>
        <ul>
          <li>копировать;</li>
          <li>изменять;</li>
          <li>распространять;</li>
          <li>продавать;</li>
          <li>сдавать в аренду;</li>
          <li>осуществлять обратную разработку;</li>
          <li>использовать в коммерческих целях;</li>
          <li>иным образом нарушать соответствующие права интеллектуальной собственности.</li>
        </ul>
        <h3>Пользовательский контент</h3>
        <p>
          Пользователи обладают соответствующими правами в отношении правомерно принадлежащего им пользовательского
          контента.
        </p>
        <p>
          При этом пользователи обязаны обеспечить, чтобы использование ими услуг Xiangji не нарушало прав каких-либо
          третьих лиц.
        </p>
        <h3>Контент, создаваемый и отображаемый Платформой</h3>
        <p>
          Xiangji может отображать на страницах продуктов, в справочном центре, в рекламных материалах или в иных местах
          образцы изображений, шаблоны, шрифты, графику, товарные знаки, образы персонажей или иные материалы.
        </p>
        <p>
          <strong>
            Без прямо выраженного разрешения Xiangji Вы не вправе использовать вышеуказанный контент в коммерческих
            целях.
          </strong>
        </p>
      </section>
      <section>
        <h2>7. Платные услуги</h2>
        <h3>Платные услуги</h3>
        <p>Некоторые продукты и функции Xiangji являются платными услугами.</p>
        <p>
          При использовании платной услуги Вы обязаны оплачивать её в соответствии с ценами, способами тарификации и
          правилами обслуживания, указанными на соответствующих страницах.
        </p>
        <h3>Корректировка цен</h3>
        <p>
          Xiangji оставляет за собой право корректировать тарифы, содержание тарифных планов, способы тарификации и
          объём сервисных кредитов с учётом развития бизнеса, технологических затрат и рыночной конъюнктуры.
        </p>
        <p>
          <strong>
            Если корректировка затрагивает уже приобретённые Вами сервисные преимущества, срок действия которых не
            истёк, Xiangji будет действовать в соответствии с применимым законодательством и соответствующим соглашением
            о покупке.
          </strong>
        </p>
        <h3>Подписочные услуги</h3>
        <p>При покупке подписки Xiangji Вы также обязаны соблюдать Соглашение о приобретении подписки Xiangji.</p>
        <p>
          Вопросы, касающиеся подписки, такие как её цена, срок, преимущества, возврат средств и автоматическое
          продление, регулируются страницей покупки подписки и соответствующим соглашением.
        </p>
        <h3>Бесплатные услуги</h3>
        <p>Xiangji может предоставлять отдельные бесплатные услуги, пробные кредиты или пробные функции.</p>
        <p>
          <strong>
            Xiangji оставляет за собой право корректировать, приостанавливать или прекращать бесплатные услуги с учётом
            хода эксплуатации продуктов.
          </strong>
        </p>
      </section>
      <section>
        <h2>8. Изменение, прерывание и прекращение услуг</h2>
        <h3>Обновление услуг</h3>
        <p>
          В целях улучшения пользовательского опыта, совершенствования функций продуктов и обеспечения безопасности
          услуг Xiangji может обновлять, модернизировать, оптимизировать, корректировать или переносить свои продукты.
        </p>
        <h3>Прерывание услуг</h3>
        <p>
          Временные перерывы в оказании услуг или их недоступность по любой из следующих причин не считаются нарушением
          обязательств Xiangji:
        </p>
        <ul>
          <li>техническое обслуживание или обновление систем;</li>
          <li>сетевые сбои;</li>
          <li>аварии у операторов электросвязи;</li>
          <li>сбои облачных служб;</li>
          <li>сбои сторонних ИИ-моделей или технических служб;</li>
          <li>хакерские атаки или инциденты кибербезопасности;</li>
          <li>обстоятельства непреодолимой силы;</li>
          <li>иные причины, находящиеся вне разумного контроля Xiangji.</li>
        </ul>
        <h3>Прекращение услуг</h3>
        <p>
          Xiangji оставляет за собой право приостановить или прекратить предоставление Вам отдельных или всех услуг при
          наступлении любого из следующих обстоятельств:
        </p>
        <ol>
          <li>Вы нарушаете законодательство;</li>
          <li>Вы нарушаете настоящие Условия или иные правила обслуживания Xiangji;</li>
          <li>Вы предоставляете недостоверную, неточную или не поддающуюся проверке информацию;</li>
          <li>этого требуют соответствующие компетентные органы;</li>
          <li>этого требуют интересы безопасности учётной записи, системы или сделок;</li>
          <li>услугу необходимо прекратить по хозяйственным, техническим или иным причинам;</li>
          <li>иные разумные обстоятельства, при которых Xiangji считает необходимым прекратить услуги.</li>
        </ol>
        <h3>Обработка данных</h3>
        <p>
          После прекращения услуг Xiangji может удалить или анонимизировать Ваши данные в соответствии с
          законодательством, Политикой конфиденциальности и применимыми правилами обслуживания.
        </p>
        <p>
          <strong>
            До прекращения услуг Вы обязаны самостоятельно создать резервные копии пользовательских данных, которые Вам
            требуется хранить в течение длительного срока.
          </strong>
        </p>
      </section>
      <section>
        <h2>9. Отказ от гарантий и ограничение ответственности</h2>
        <h3>Обстоятельства непреодолимой силы</h3>
        <p>
          В пределах, допускаемых законом, Xiangji не несёт ответственности за нарушение договора, если услуги не могут
          предоставляться в обычном режиме вследствие обстоятельств непреодолимой силы.
        </p>
        <p>Обстоятельства непреодолимой силы включают, помимо прочего:</p>
        <ul>
          <li>землетрясения;</li>
          <li>тайфуны;</li>
          <li>наводнения;</li>
          <li>пожары;</li>
          <li>войны;</li>
          <li>действия органов государственной власти;</li>
          <li>крупные события в сфере общественного здравоохранения;</li>
          <li>кибератаки;</li>
          <li>масштабные сетевые аварии;</li>
          <li>иные события, которые невозможно разумно предвидеть, предотвратить или преодолеть.</li>
        </ul>
        <h3>Услуги третьих лиц</h3>
        <p>
          Некоторые услуги Xiangji зависят от сторонних сетей, платёжных служб, облачных вычислений, ИИ-моделей, систем
          перевода и иных служб.
        </p>
        <p>
          <strong>
            При нарушениях услуг, вызванных сбоями, корректировками, ограничениями или прекращением сторонних служб,
            Xiangji приложит разумные усилия для содействия в их устранении, но не несёт ответственности за убытки,
            находящиеся вне разумного контроля Xiangji.
          </strong>
        </p>
        <h3>Риски, связанные с поведением пользователей</h3>
        <p>Вы понимаете и соглашаетесь, что использованию интернет- и ИИ-услуг присущи определённые риски.</p>
        <p>
          Xiangji не несёт ответственности сверх установленной законом за информацию, контент, поведение и риски,
          исходящие от других пользователей, третьих лиц или интернет-среды.
        </p>
        <h3>Риски ИИ-услуг</h3>
        <p>
          <strong>
            Xiangji не гарантирует, что контент, генерируемый ИИ, абсолютно точен, полон, достоверен, надёжен или
            пригоден для какой-либо конкретной коммерческой цели.
          </strong>
        </p>
        <p>
          Пользователи обязаны самостоятельно оценивать и проверять контент с учётом своих фактических сценариев
          использования.
        </p>
        <h3>Косвенные убытки</h3>
        <p>
          В максимальной степени, допускаемой законом, Xiangji не несёт ответственности за какие-либо косвенные убытки,
          упущенную выгоду, ущерб деловой репутации, убытки от прерывания коммерческой деятельности или иные особые
          убытки, возникшие в связи с использованием или невозможностью использования услуг Xiangji.
        </p>
        <p>
          <strong>
            В случаях, когда закон требует возложения на Xiangji ответственности, её объём ограничен тем, что
            предусмотрено законом.
          </strong>
        </p>
      </section>
      <section>
        <h2>10. Работа с нарушениями и юридическая ответственность</h2>
        <h3>Работа с нарушениями</h3>
        <p>
          Если Xiangji обнаружит или получит сообщение либо жалобу о том, что Вы совершали действия, нарушающие
          законодательство, настоящие Условия или иные правила обслуживания, Xiangji оставляет за собой право с учётом
          фактических обстоятельств принять:
        </p>
        <ul>
          <li>предупреждение;</li>
          <li>удаление или блокировку соответствующего контента;</li>
          <li>ограничение соответствующих функций;</li>
          <li>ограничение доступа к учётной записи;</li>
          <li>приостановку услуг;</li>
          <li>заморозку учётной записи;</li>
          <li>удаление учётной записи;</li>
          <li>иные разумные меры.</li>
        </ul>
        <h3>Прекращение учётной записи</h3>
        <p>
          <strong>
            Если Ваше поведение грубо нарушает законодательство, настоящие Условия или иные правила платформы, Xiangji
            оставляет за собой право приостановить или навсегда прекратить действие Вашей учётной записи и связанных
            услуг.
          </strong>
        </p>
        <p>
          Если услуги прекращены вследствие нарушения, Вы можете утратить возможность использовать соответствующие
          сервисные преимущества, имеющиеся в Вашей учётной записи.
        </p>
        <h3>Возмещение убытков пользователем</h3>
        <p>
          <strong>
            Если в результате Ваших незаконных действий или действий, не соответствующих требованиям, нарушающих права
            актов либо нарушений настоящих Условий Xiangji, его аффилированные лица или партнёры понесут претензии
            третьих лиц, административные взыскания, судебные разбирательства, арбитраж или иные убытки, Вы обязаны
            нести соответствующую ответственность в соответствии с законом и возместить Xiangji причинённые этим
            разумные убытки.
          </strong>
        </p>
      </section>
      <section>
        <h2>11. Конфиденциальность и защита персональных данных</h2>
        <p>Xiangji придаёт большое значение защите Вашей персональной информации и частной жизни.</p>
        <p>
          Сведения о том, как мы собираем, используем, храним, защищаем и обрабатываем Вашу персональную информацию,
          приведены в Политике конфиденциальности, опубликованной Xiangji.
        </p>
        <p>
          <strong>
            Вы обязаны внимательно прочитать и понять соответствующую политику конфиденциальности до регистрации, входа
            или использования услуг Xiangji.
          </strong>
        </p>
        <p>
          Если конкретная услуга предполагает трансграничную передачу данных, использование сторонних ИИ-моделей или
          иные особые сценарии обработки данных, Xiangji будет обрабатывать такие данные в соответствии с применимым
          законодательством и соответствующей политикой конфиденциальности.
        </p>
      </section>
      <section>
        <h2>12. Услуги третьих лиц и ссылки</h2>
        <p>
          Услуги Xiangji могут содержать сторонние веб-сайты, программное обеспечение, API, платёжные службы, ИИ-модели
          или иные службы, а также подключаться к ним.
        </p>
        <p>
          <strong>
            Сторонние службы предоставляются соответствующими третьими лицами самостоятельно, и Xiangji не гарантирует
            точность, надёжность, правомерность или непрерывную доступность сторонних служб сверх пределов,
            установленных законом.
          </strong>
        </p>
        <p>
          При использовании сторонней службы Вы обязаны соблюдать условия её обслуживания и политику конфиденциальности
          соответствующего третьего лица.
        </p>
        <p>
          Споры, возникающие в связи с использованием Вами сторонних служб, по общему правилу разрешаются между Вами и
          соответствующим третьим лицом.
        </p>
      </section>
      <section>
        <h2>13. Обратная связь по услугам</h2>
        <p>
          Если Вы предоставляете Xiangji комментарии, предложения, отзывы о продуктах или иную информацию, Вы
          соглашаетесь, что Xiangji может — при условии ненарушения Ваших законных прав и интересов — использовать такую
          обратную связь для улучшения продуктов, технической оптимизации и организации обслуживания.
        </p>
        <p>
          Вы понимаете и соглашаетесь, что, если стороны письменно не согласились об ином, Xiangji не несёт
          обязательства выплачивать Вам какое-либо вознаграждение за принятие Ваших комментариев или предложений.
        </p>
      </section>
      <section>
        <h2>14. Прекращение действия настоящих Условий</h2>
        <ol>
          <li>
            Настоящие Условия вступают в силу с даты Вашей регистрации, входа или первого использования услуг Xiangji и
            действуют до аннулирования Вами учётной записи либо до прекращения Xiangji предоставления Вам услуг.
          </li>
          <li>
            После прекращения действия настоящих Условий те положения, которые по своей природе должны сохранять
            действие после такого прекращения, включая, помимо прочего, положения об интеллектуальной собственности, об
            ответственности пользователя, об отказе от гарантий, об ограничении ответственности и о разрешении споров,
            продолжают действовать.
          </li>
        </ol>
      </section>
      <section>
        <h2>15. Применимое право, юрисдикция и заключительные положения</h2>
        <ol>
          <li>
            <strong>
              Образование, действительность, исполнение, толкование, изменение и прекращение настоящих Условий, а также
              разрешение вытекающих из них споров регулируются законодательством Китайской Народной Республики.
            </strong>
          </li>
          <li>
            В случае спора, возникающего из настоящих Условий или из использования Вами услуг Xiangji, стороны стремятся
            разрешить его прежде всего путём дружественных переговоров.
          </li>
          <li>
            <strong>
              Если переговоры не приведут к результату, любая из сторон вправе обратиться с иском в народный суд
              компетентной юрисдикции по месту нахождения фактического оператора Xiangji.
            </strong>
          </li>
          <li>
            Если какое-либо положение настоящих Условий признано компетентным судом недействительным, противоправным или
            не подлежащим принудительному исполнению, действительность остальных положений не затрагивается.
          </li>
          <li>
            Заголовки в настоящих Условиях приведены исключительно для удобства чтения и не влияют на толкование
            положений или их правовые последствия.
          </li>
        </ol>
      </section>
      <section>
        <h2>16. Свяжитесь с нами</h2>
        <p>
          Если у Вас есть вопросы, комментарии или жалобы в отношении настоящих Условий, продуктов Xiangji или
          соответствующих услуг, Вы можете связаться с нами по следующим каналам:
        </p>
        <ul>
          <li>
            Официальный веб-сайт:{' '}
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>
            <strong>Онлайн-поддержка:</strong> встроенная в продукты Xiangji служба онлайн-поддержки клиентов
          </li>
          <li>
            <strong>Адрес электронной почты поддержки:</strong> [Официальный адрес поддержки — будет предоставлен]
          </li>
          <li>
            <strong>Оператор:</strong> [Полное юридическое наименование фактического оператора — будет предоставлено]
          </li>
          <li>
            <strong>Регистрационный адрес:</strong> [Регистрационный адрес — будет предоставлен]
          </li>
        </ul>
        <p>Мы рассмотрим Ваши запросы или отзывы в разумный срок после их получения.</p>
      </section>
    </>
  );
};

export default RuContent;
